import admin from './admin'
import chat from './chat'
import landing from './landing'
import web from './web'

export default {
  web,
  admin,
  landing,
  chat,
  message: {
    loadingFailed: '加载失败',
    loadingTip: '加载中...'
  },
  common: {
    id: '编号',
    show: '查看',
    loading: '加载中...',
    username: '用户名',
    search: '查询',
    reset: '重置',
    add: '添加',
    edit: '编辑',
    delete: '删除',
    cancel: '取消',
    confirm: '确认',
    save: '保存',
    back: '返回',
    success: '操作成功',
    error: '操作失败',
    required: '必填项',
    pleaseSelect: '请选择',
    pleaseInput: '请输入',
    close: '关闭',
    submit: '提交',
    operation: '操作',
    confirmDelete: '确定要删除吗?',
    deleteConfirm: '确定要删除吗？',
    createdAt: '创建时间',
    too_long: '长度超出限制 (最多 {count} 个字符)',
    tooltip: {
      overview: '总览',
      aigc: 'AIGC',
      system: '系统管理'
    },
    mobile: {
      menu: '菜单',
      close: '关闭',
      toggleMenu: '切换菜单'
    }
  },
  components: {
    empty: {
      description: '暂无数据',
      noData: '暂无数据',
      noResult: '暂无搜索结果',
      noPermission: '暂无权限'
    },
    userDropdown: {
      profile: '个人资料',
      settings: '设置',
      logout: '退出登录'
    }
  },
  form: {
    validation: {
      email: {
        required: '请填写邮箱',
        invalid: '请输入有效的邮箱地址'
      },
      password: {
        required: '请填写密码',
        minLength: '密码长度不能小于6位'
      },
      passwordConfirmation: {
        required: '请填写密码确认',
        notMatch: '两次输入的密码不一致'
      }
    }
  },
  error: {
    goHome: '返回主页',
    messages: {
      500: '服务器出现错误',
      404: '页面未找到',
      403: '禁止访问',
      401: '未授权访问',
      default: '出现了未知错误'
    }
  },
  auth: {
    login: {
      title: '登录',
      welcome: '欢迎回来',
      description: '请登录以继续',
      email: '邮箱',
      emailPlaceholder: '请输入邮箱',
      password: '密码',
      passwordPlaceholder: '请输入密码',
      rememberMe: '记住我',
      submit: '登录',
      forgotPassword: '忘记密码？',
      noAccount: '还没有账号？',
      signUp: '注册',
      loginAccount: '已有账号？立即登录',
      goToRegister: '创建账号',
      errors: {
        invalidCredentials: '邮箱或密码错误',
        accountLocked: '账号已被锁定',
        general: '登录时发生错误'
      }
    },
    logout: {
      title: '退出登录',
      confirm: '确定要退出登录吗？',
      success: '已成功退出登录'
    }
  },
  flash: {
    actions: {
      create: {
        success: '创建成功',
        error: '创建失败'
      },
      update: {
        success: '更新成功',
        error: '更新失败'
      },
      destroy: {
        success: '删除成功',
        error: '删除失败'
      }
    }
  }
}
